/* eslint-disable @typescript-eslint/naming-convention */

export enum Sprites {
    tile_lumber = 'tile_lumber',
    tile_brick = 'tile_brick',
    tile_wool = 'tile_wool',
    tile_grain = 'tile_grain',
    tile_ore = 'tile_ore',
    tile_desert = 'tile_desert',
    tile_gold = 'tile_gold',
    tile_fog = 'tile_fog',

    ship_red_north_west = 'ship_red_north_west',
    ship_red_west = 'ship_red_west',
    ship_red_south_west = 'ship_red_south_west',
    ship_black_north_west = 'ship_black_north_west',
    ship_black_west = 'ship_black_west',
    ship_black_south_west = 'ship_black_south_west',
    ship_blue_north_west = 'ship_blue_north_west',
    ship_blue_west = 'ship_blue_west',
    ship_blue_south_west = 'ship_blue_south_west',
    ship_bronze_north_west = 'ship_bronze_north_west',
    ship_bronze_west = 'ship_bronze_west',
    ship_bronze_south_west = 'ship_bronze_south_west',
    ship_gold_north_west = 'ship_gold_north_west',
    ship_gold_west = 'ship_gold_west',
    ship_gold_south_west = 'ship_gold_south_west',
    ship_green_north_west = 'ship_green_north_west',
    ship_green_west = 'ship_green_west',
    ship_green_south_west = 'ship_green_south_west',
    ship_mysticblue_north_west = 'ship_mysticblue_north_west',
    ship_mysticblue_west = 'ship_mysticblue_west',
    ship_mysticblue_south_west = 'ship_mysticblue_south_west',
    ship_orange_north_west = 'ship_orange_north_west',
    ship_orange_west = 'ship_orange_west',
    ship_orange_south_west = 'ship_orange_south_west',
    ship_purple_north_west = 'ship_purple_north_west',
    ship_purple_west = 'ship_purple_west',
    ship_purple_south_west = 'ship_purple_south_west',
    ship_silver_north_west = 'ship_silver_north_west',
    ship_silver_west = 'ship_silver_west',
    ship_silver_south_west = 'ship_silver_south_west',
    ship_white_north_west = 'ship_white_north_west',
    ship_white_west = 'ship_white_west',
    ship_white_south_west = 'ship_white_south_west',
    ship_pink_north_west = 'ship_pink_north_west',
    ship_pink_west = 'ship_pink_west',
    ship_pink_south_west = 'ship_pink_south_west',
    ship_highlight_north_west = 'ship_highlight_north_west',
    ship_highlight_west = 'ship_highlight_west',
    ship_highlight_south_west = 'ship_highlight_south_west',

    ship_move_black = 'ship_move_black',
    ship_move_blue = 'ship_move_blue',
    ship_move_bronze = 'ship_move_bronze',
    ship_move_gold = 'ship_move_gold',
    ship_move_green = 'ship_move_green',
    ship_move_mysticblue = 'ship_move_mysticblue',
    ship_move_orange = 'ship_move_orange',
    ship_move_purple = 'ship_move_purple',
    ship_move_red = 'ship_move_red',
    ship_move_silver = 'ship_move_silver',
    ship_move_white = 'ship_move_white',
    ship_move_pink = 'ship_move_pink',

    move_ship_arrow = 'move_ship_arrow',

    // All shore tiles start with TopRight as the first location of shore
    tile_sea = 'tile_sea',
    tile_shore_1 = 'tile_shore_1',
    tile_shore_2_sswwww = 'tile_shore_2_sswwww',
    tile_shore_2_swswww = 'tile_shore_2_swswww',
    tile_shore_2_swwsww = 'tile_shore_2_swwsww',
    tile_shore_3_ssswww = 'tile_shore_3_ssswww',
    tile_shore_3_sswwsw = 'tile_shore_3_sswwsw',
    tile_shore_3_sswsww = 'tile_shore_3_sswsww',
    tile_shore_3_swswsw = 'tile_shore_3_swswsw',
    tile_shore_4_ssssww = 'tile_shore_4_ssssww',
    tile_shore_4_ssswsw = 'tile_shore_4_ssswsw',
    tile_shore_4_sswssw = 'tile_shore_4_sswssw',
    tile_shore_5 = 'tile_shore_5',
    tile_shore_6 = 'tile_shore_6',

    prob_2 = 'prob_2',
    prob_3 = 'prob_3',
    prob_4 = 'prob_4',
    prob_5 = 'prob_5',
    prob_6 = 'prob_6',
    prob_8 = 'prob_8',
    prob_9 = 'prob_9',
    prob_10 = 'prob_10',
    prob_11 = 'prob_11',
    prob_12 = 'prob_12',

    icon_colonist_coin = 'icon_colonist_coin',
    icon_robber = 'icon_robber',
    icon_robber_santa = 'icon_robber_santa',
    icon_robber_lunar = 'icon_robber_lunar',
    icon_robber_cupid = 'icon_robber_cupid',
    icon_robber_tie = 'icon_robber_tie',
    icon_hourglass = 'icon_hourglass',
    icon_bot = 'icon_bot',
    icon_pencil = 'icon_pencil',
    icon_players = 'icon_players',
    icon_trade_bank_check = 'icon_trade_bank_check',
    icon_trade_opponents_check = 'icon_trade_opponents_check',
    logo = 'logo',
    bank = 'bank',

    icon_merchant_black = 'icon_merchant_black',
    icon_merchant_blue = 'icon_merchant_blue',
    icon_merchant_bronze = 'icon_merchant_bronze',
    icon_merchant_gold = 'icon_merchant_gold',
    icon_merchant_green = 'icon_merchant_green',
    icon_merchant_mysticblue = 'icon_merchant_mysticblue',
    icon_merchant_orange = 'icon_merchant_orange',
    icon_merchant_purple = 'icon_merchant_purple',
    icon_merchant_red = 'icon_merchant_red',
    icon_merchant_silver = 'icon_merchant_silver',
    icon_merchant_white = 'icon_merchant_white',
    icon_merchant_pink = 'icon_merchant_pink',

    medal_gold = 'medal_gold',
    medal_silver = 'medal_silver',
    medal_bronze = 'medal_bronze',

    icon_elephant = 'icon_elephant',
    icon_sombrero = 'icon_sombrero',
    icon_farmer = 'icon_farmer',
    icon_avocado = 'icon_avocado',
    icon_cactus = 'icon_cactus',
    icon_crown = 'icon_crown',
    icon_swords = 'icon_swords',
    icon_swords_highlight = 'icon_swords_highlight',
    icon_helmet = 'icon_helmet',
    icon_snorkel = 'icon_snorkel',
    icon_scarf = 'icon_scarf',
    icon_tie = 'icon_tie',
    icon_worker = 'icon_worker',
    icon_mummy = 'icon_mummy',
    icon_gifter = 'icon_gifter',

    city_white = 'city_white',
    city_blue = 'city_blue',
    city_red = 'city_red',
    city_orange = 'city_orange',
    city_green = 'city_green',
    city_gold = 'city_gold',
    city_silver = 'city_silver',
    city_bronze = 'city_bronze',
    city_purple = 'city_purple',
    city_black = 'city_black',
    city_mysticblue = 'city_mysticblue',
    city_pink = 'city_pink',

    city_destroyed_white = 'city_destroyed_white',
    city_destroyed_blue = 'city_destroyed_blue',
    city_destroyed_red = 'city_destroyed_red',
    city_destroyed_orange = 'city_destroyed_orange',
    city_destroyed_green = 'city_destroyed_green',
    city_destroyed_gold = 'city_destroyed_gold',
    city_destroyed_silver = 'city_destroyed_silver',
    city_destroyed_bronze = 'city_destroyed_bronze',
    city_destroyed_purple = 'city_destroyed_purple',
    city_destroyed_black = 'city_destroyed_black',
    city_destroyed_mysticblue = 'city_destroyed_mysticblue',
    city_destroyed_pink = 'city_destroyed_pink',

    city_wall_white = 'city_wall_white',
    city_wall_blue = 'city_wall_blue',
    city_wall_red = 'city_wall_red',
    city_wall_orange = 'city_wall_orange',
    city_wall_green = 'city_wall_green',
    city_wall_gold = 'city_wall_gold',
    city_wall_silver = 'city_wall_silver',
    city_wall_bronze = 'city_wall_bronze',
    city_wall_purple = 'city_wall_purple',
    city_wall_black = 'city_wall_black',
    city_wall_mysticblue = 'city_wall_mysticblue',
    city_wall_pink = 'city_wall_pink',

    road_white = 'road_white',
    road_blue = 'road_blue',
    road_red = 'road_red',
    road_orange = 'road_orange',
    road_green = 'road_green',
    road_gold = 'road_gold',
    road_silver = 'road_silver',
    road_bronze = 'road_bronze',
    road_purple = 'road_purple',
    road_black = 'road_black',
    road_mysticblue = 'road_mysticblue',
    road_pink = 'road_pink',
    road_highlight = 'road_highlight',

    settlement_white = 'settlement_white',
    settlement_blue = 'settlement_blue',
    settlement_red = 'settlement_red',
    settlement_orange = 'settlement_orange',
    settlement_green = 'settlement_green',
    settlement_gold = 'settlement_gold',
    settlement_silver = 'settlement_silver',
    settlement_bronze = 'settlement_bronze',
    settlement_purple = 'settlement_purple',
    settlement_black = 'settlement_black',
    settlement_mysticblue = 'settlement_mysticblue',
    settlement_pink = 'settlement_pink',

    knight_level1_active_black = 'knight_level1_active_black',
    knight_level1_active_blue = 'knight_level1_active_blue',
    knight_level1_active_bronze = 'knight_level1_active_bronze',
    knight_level1_active_gold = 'knight_level1_active_gold',
    knight_level1_active_green = 'knight_level1_active_green',
    knight_level1_active_mysticblue = 'knight_level1_active_mysticblue',
    knight_level1_active_orange = 'knight_level1_active_orange',
    knight_level1_active_purple = 'knight_level1_active_purple',
    knight_level1_active_red = 'knight_level1_active_red',
    knight_level1_active_silver = 'knight_level1_active_silver',
    knight_level1_active_white = 'knight_level1_active_white',
    knight_level1_active_pink = 'knight_level1_active_pink',

    knight_level2_active_black = 'knight_level2_active_black',
    knight_level2_active_blue = 'knight_level2_active_blue',
    knight_level2_active_bronze = 'knight_level2_active_bronze',
    knight_level2_active_gold = 'knight_level2_active_gold',
    knight_level2_active_green = 'knight_level2_active_green',
    knight_level2_active_mysticblue = 'knight_level2_active_mysticblue',
    knight_level2_active_orange = 'knight_level2_active_orange',
    knight_level2_active_purple = 'knight_level2_active_purple',
    knight_level2_active_red = 'knight_level2_active_red',
    knight_level2_active_silver = 'knight_level2_active_silver',
    knight_level2_active_white = 'knight_level2_active_white',
    knight_level2_active_pink = 'knight_level2_active_pink',

    knight_level3_active_black = 'knight_level3_active_black',
    knight_level3_active_blue = 'knight_level3_active_blue',
    knight_level3_active_bronze = 'knight_level3_active_bronze',
    knight_level3_active_gold = 'knight_level3_active_gold',
    knight_level3_active_green = 'knight_level3_active_green',
    knight_level3_active_mysticblue = 'knight_level3_active_mysticblue',
    knight_level3_active_orange = 'knight_level3_active_orange',
    knight_level3_active_purple = 'knight_level3_active_purple',
    knight_level3_active_red = 'knight_level3_active_red',
    knight_level3_active_silver = 'knight_level3_active_silver',
    knight_level3_active_white = 'knight_level3_active_white',
    knight_level3_active_pink = 'knight_level3_active_pink',

    knight_level1_inactive_black = 'knight_level1_inactive_black',
    knight_level1_inactive_blue = 'knight_level1_inactive_blue',
    knight_level1_inactive_bronze = 'knight_level1_inactive_bronze',
    knight_level1_inactive_gold = 'knight_level1_inactive_gold',
    knight_level1_inactive_green = 'knight_level1_inactive_green',
    knight_level1_inactive_mysticblue = 'knight_level1_inactive_mysticblue',
    knight_level1_inactive_orange = 'knight_level1_inactive_orange',
    knight_level1_inactive_purple = 'knight_level1_inactive_purple',
    knight_level1_inactive_red = 'knight_level1_inactive_red',
    knight_level1_inactive_silver = 'knight_level1_inactive_silver',
    knight_level1_inactive_white = 'knight_level1_inactive_white',
    knight_level1_inactive_pink = 'knight_level1_inactive_pink',

    knight_level2_inactive_black = 'knight_level2_inactive_black',
    knight_level2_inactive_blue = 'knight_level2_inactive_blue',
    knight_level2_inactive_bronze = 'knight_level2_inactive_bronze',
    knight_level2_inactive_gold = 'knight_level2_inactive_gold',
    knight_level2_inactive_green = 'knight_level2_inactive_green',
    knight_level2_inactive_mysticblue = 'knight_level2_inactive_mysticblue',
    knight_level2_inactive_orange = 'knight_level2_inactive_orange',
    knight_level2_inactive_purple = 'knight_level2_inactive_purple',
    knight_level2_inactive_red = 'knight_level2_inactive_red',
    knight_level2_inactive_silver = 'knight_level2_inactive_silver',
    knight_level2_inactive_white = 'knight_level2_inactive_white',
    knight_level2_inactive_pink = 'knight_level2_inactive_pink',

    knight_level3_inactive_black = 'knight_level3_inactive_black',
    knight_level3_inactive_blue = 'knight_level3_inactive_blue',
    knight_level3_inactive_bronze = 'knight_level3_inactive_bronze',
    knight_level3_inactive_gold = 'knight_level3_inactive_gold',
    knight_level3_inactive_green = 'knight_level3_inactive_green',
    knight_level3_inactive_mysticblue = 'knight_level3_inactive_mysticblue',
    knight_level3_inactive_orange = 'knight_level3_inactive_orange',
    knight_level3_inactive_purple = 'knight_level3_inactive_purple',
    knight_level3_inactive_red = 'knight_level3_inactive_red',
    knight_level3_inactive_silver = 'knight_level3_inactive_silver',
    knight_level3_inactive_white = 'knight_level3_inactive_white',
    knight_level3_inactive_pink = 'knight_level3_inactive_pink',

    knight_move_black = 'knight_move_black',
    knight_move_blue = 'knight_move_blue',
    knight_move_bronze = 'knight_move_bronze',
    knight_move_gold = 'knight_move_gold',
    knight_move_green = 'knight_move_green',
    knight_move_mysticblue = 'knight_move_mysticblue',
    knight_move_orange = 'knight_move_orange',
    knight_move_purple = 'knight_move_purple',
    knight_move_red = 'knight_move_red',
    knight_move_silver = 'knight_move_silver',
    knight_move_white = 'knight_move_white',
    knight_move_pink = 'knight_move_pink',

    knight_active_level1 = 'knight_active_level1',

    metropolis_science = 'metropolis_science',
    metropolis_trade = 'metropolis_trade',
    metropolis_politics = 'metropolis_politics',

    port_pier = 'port_pier',
    port = 'port',
    port_lumber = 'port_lumber',
    port_brick = 'port_brick',
    port_wool = 'port_wool',
    port_grain = 'port_grain',
    port_ore = 'port_ore',
    port_highlight = 'port_highlight',

    card_lumber = 'card_lumber',
    card_brick = 'card_brick',
    card_wool = 'card_wool',
    card_grain = 'card_grain',
    card_ore = 'card_ore',
    card_rescardback = 'card_rescardback',
    card_rescardoverlimit = 'card_rescardoverlimit',
    card_vp = 'card_vp',
    card_knight = 'card_knight',
    card_yearofplenty = 'card_yearofplenty',
    card_monopoly = 'card_monopoly',
    card_roadbuilding = 'card_roadbuilding',
    card_badge_background = 'card_badge_background',
    card_paper = 'card_paper',
    card_cloth = 'card_cloth',
    card_coin = 'card_coin',

    card_overlay_blue = 'card_overlay_blue',
    card_overlay_black = 'card_overlay_black',
    card_overlay_white = 'card_overlay_white',

    card_progress_back = 'card_progress_back',
    card_progress_politics_back = 'card_progress_politics_back',
    card_progress_politics_bishop = 'card_progress_politics_bishop',
    card_progress_politics_constitution = 'card_progress_politics_constitution',
    card_progress_politics_deserter = 'card_progress_politics_deserter',
    card_progress_politics_diplomat = 'card_progress_politics_diplomat',
    card_progress_politics_intrigue = 'card_progress_politics_intrigue',
    card_progress_politics_saboteur = 'card_progress_politics_saboteur',
    card_progress_politics_spy = 'card_progress_politics_spy',
    card_progress_politics_warlord = 'card_progress_politics_warlord',
    card_progress_politics_wedding = 'card_progress_politics_wedding',
    card_progress_science_back = 'card_progress_science_back',
    card_progress_science_alchemist = 'card_progress_science_alchemist',
    card_progress_science_crane = 'card_progress_science_crane',
    card_progress_science_engineer = 'card_progress_science_engineer',
    card_progress_science_inventor = 'card_progress_science_inventor',
    card_progress_science_irrigation = 'card_progress_science_irrigation',
    card_progress_science_medicine = 'card_progress_science_medicine',
    card_progress_science_mining = 'card_progress_science_mining',
    card_progress_science_printer = 'card_progress_science_printer',
    card_progress_science_road_building = 'card_progress_science_road_building',
    card_progress_science_smith = 'card_progress_science_smith',
    card_progress_trade_back = 'card_progress_trade_back',
    card_progress_trade_commercial_harbor = 'card_progress_trade_commercial_harbor',
    card_progress_trade_master_merchant = 'card_progress_trade_master_merchant',
    card_progress_trade_merchant_fleet = 'card_progress_trade_merchant_fleet',
    card_progress_trade_merchant = 'card_progress_trade_merchant',
    card_progress_trade_resource_monopoly = 'card_progress_trade_resource_monopoly',
    card_progress_trade_commodity_monopoly = 'card_progress_trade_commodity_monopoly',

    partition = 'partition',

    dice_1 = 'dice_1',
    dice_2 = 'dice_2',
    dice_3 = 'dice_3',
    dice_4 = 'dice_4',
    dice_5 = 'dice_5',
    dice_6 = 'dice_6',

    dice_red_1 = 'dice_red_1',
    dice_red_2 = 'dice_red_2',
    dice_red_3 = 'dice_red_3',
    dice_red_4 = 'dice_red_4',
    dice_red_5 = 'dice_red_5',
    dice_red_6 = 'dice_red_6',

    dice = 'dice',
    dice_marker = 'dice_marker',

    dice_background_politics = 'dice_background_politics',
    dice_background_science = 'dice_background_science',
    dice_background_trade = 'dice_background_trade',

    dice_event_barbarian = 'dice_event_barbarian',
    dice_event_politics = 'dice_event_politics',
    dice_event_science = 'dice_event_science',
    dice_event_trade = 'dice_event_trade',

    icon_gamemode_citiesandknights = 'icon_gamemode_citiesandknights',

    icon_player = 'icon_player',
    icon_player_loggedin = 'icon_player_loggedin',
    icon_settler = 'icon_settler',
    icon_colonist = 'icon_colonist',
    icon_founder = 'icon_founder',
    icon_christmas_hat = 'icon_christmas_hat',
    icon_pirate_ship = 'icon_pirate_ship',
    icon_discard_resource_cards = 'icon_discard_resource_cards',
    icon_discard_progress_cards = 'icon_discard_progress_cards',
    icon_aqueduct = 'icon_aqueduct',
    icon_fortress = 'icon_fortress',
    icon_tradehouse = 'icon_tradehouse',

    stat_vp = 'stat_vp',
    stat_largest_army = 'stat_largest_army',
    icon_largest_army_highlight = 'icon_largest_army_highlight',
    stat_longest_road = 'stat_longest_road',
    icon_longest_road_highlight = 'icon_longest_road_highlight',
    stat_chits = 'stat_chits',
    stat_defender = 'stat_defender',
    stat_metropolis = 'stat_metropolis',
    stat_merchant = 'stat_merchant',
    stat_mmr_change = 'stat_mmr_change',

    stat_dev_card_income = 'stat_dev_card_income',
    stat_dev_card_loss = 'stat_dev_card_loss',
    stat_dev_card_bought = 'stat_dev_card_bought',
    stat_dev_card_used = 'stat_dev_card_used',
    stat_proposed_trades = 'stat_proposed_trades',
    stat_res_gain = 'stat_res_gain',
    stat_res_loss = 'stat_res_loss',
    stat_res_score = 'stat_res_score',
    stat_resource_income_blocked = 'stat_resource_income_blocked',
    stat_resources_used = 'stat_resources_used',
    stat_robbing_income = 'stat_robbing_income',
    stat_robbing_loss = 'stat_robbing_loss',
    stat_rolling_income = 'stat_rolling_income',
    stat_rolling_loss = 'stat_rolling_loss',
    stat_successful_trades = 'stat_successful_trades',
    stat_trade_income = 'stat_trade_income',
    stat_trade_loss = 'stat_trade_loss',
    stat_gold_income = 'stat_gold_income',

    icon_lock_on = 'icon_lock_on',
    icon_lock_off = 'icon_lock_off',
    icon_trade_arrow_red = 'icon_trade_arrow_red',
    icon_trade_arrow_green = 'icon_trade_arrow_green',
    icon_trophy = 'icon_trophy',
    icon_chit = 'icon_chit',
    icon_check = 'icon_check',
    icon_x = 'icon_x',
    icon_trade = 'icon_trade',
    card_devcardback = 'card_devcardback',
    icon_pass_turn = 'icon_pass_turn',
    icon_special_build_phase_flag = 'icon_special_build_phase_flag',
    icon_add_friend = 'icon_add_friend',
    icon_report = 'icon_report',
    icon_longest_road = 'icon_longest_road',
    icon_largest_army = 'icon_largest_army',
    icon_highlight_circle = 'icon_highlight_circle',
    icon_highlight_circle_white = 'icon_highlight_circle_white',
    icon_square_active_politics = 'icon_square_active_politics',
    icon_square_active_science = 'icon_square_active_science',
    icon_square_active_trade = 'icon_square_active_trade',
    icon_square_inactive_politics = 'icon_square_inactive_politics',
    icon_square_inactive_science = 'icon_square_inactive_science',
    icon_square_inactive_trade = 'icon_square_inactive_trade',
    icon_square_frame = 'icon_square_frame',
    icon_square_framed_politics = 'icon_square_framed_politics',
    icon_square_framed_science = 'icon_square_framed_science',
    icon_square_framed_trade = 'icon_square_framed_trade',
    icon_highlight_square_white = 'icon_highlight_square_white',
    icon_highlight_square_yellow = 'icon_highlight_square_yellow',
    icon_arrow_player_profile = 'icon_arrow_player_profile',
    icon_arrow_player_profile_white = 'icon_arrow_player_profile_white',
    icon_defender = 'icon_defender',
    icon_triangle_politics = 'icon_triangle_politics',
    icon_triangle_science = 'icon_triangle_science',
    icon_triangle_trade = 'icon_triangle_trade',
    icon_arrow_white = 'icon_arrow_white',
    icon_beginner_hint = 'icon_beginner_hint',
    avatar_embargo_overlay = 'avatar_embargo_overlay',
    execute_button_embargo_overlay = 'execute_button_embargo_overlay',

    icon_knight_upgrade = 'icon_knight_upgrade',

    player_bg_black = 'player_bg_black',
    player_bg_blue = 'player_bg_blue',
    player_bg_bronze = 'player_bg_bronze',
    player_bg_gold = 'player_bg_gold',
    player_bg_green = 'player_bg_green',
    player_bg_orange = 'player_bg_orange',
    player_bg_purple = 'player_bg_purple',
    player_bg_red = 'player_bg_red',
    player_bg_silver = 'player_bg_silver',
    player_bg_mysticblue = 'player_bg_mysticblue',
    player_bg_white = 'player_bg_white',
    player_bg_pink = 'player_bg_pink',

    player_highlight = 'player_highlight',

    bg_section = 'bg_section',
    bg_section_dark = 'bg_section_dark',
    bg_player_inactive = 'bg_player_inactive',
    bg_button = 'bg_button',
    bg_button_active = 'bg_button_active',
    bg_button_inactive = 'bg_button_inactive',
    bg_button_green_cta = 'bg_button_green_cta',
    bg_button_hollow_cta = 'bg_button_hollow_cta',
    bg_button_highlight = 'bg_button_highlight',
    bg_text_button_active = 'bg_text_button_active',
    bg_text_button_inactive = 'bg_text_button_inactive',
    bg_player_background = 'bg_player_background',
    bg_player_additional_info_dropdown = 'bg_player_additional_info_dropdown',

    bg_button_white = 'bg_button_white',
    bg_button_blue = 'bg_button_blue',
    bg_button_red = 'bg_button_red',
    bg_button_pink = 'bg_button_pink',
    bg_button_orange = 'bg_button_orange',
    bg_button_green = 'bg_button_green',
    bg_button_gold = 'bg_button_gold',
    bg_button_silver = 'bg_button_silver',
    bg_button_bronze = 'bg_button_bronze',
    bg_button_purple = 'bg_button_purple',
    bg_button_black = 'bg_button_black',
    bg_button_mysticblue = 'bg_button_mysticblue',

    bg_button_trade = 'bg_button_trade',
    bg_button_trade_highlight = 'bg_button_trade_highlight',

    button_badge_background_white = 'button_badge_background_white',
    button_badge_background_blue = 'button_badge_background_blue',
    button_badge_background_red = 'button_badge_background_red',
    button_badge_background_orange = 'button_badge_background_orange',
    button_badge_background_green = 'button_badge_background_green',
    button_badge_background_gold = 'button_badge_background_gold',
    button_badge_background_silver = 'button_badge_background_silver',
    button_badge_background_bronze = 'button_badge_background_bronze',
    button_badge_background_purple = 'button_badge_background_purple',
    button_badge_background_black = 'button_badge_background_black',
    button_badge_background_mysticblue = 'button_badge_background_mysticblue',
    button_badge_background_pink = 'button_badge_background_pink',

    barbarian_tracker_hex_active = 'barbarian_tracker_hex_active',
    barbarian_tracker_hex_inactive = 'barbarian_tracker_hex_inactive',
    barbarian_tracker_hex_attack = 'barbarian_tracker_hex_attack',
    icon_barbarian_axes = 'icon_barbarian_axes',
    icon_barbarian_ship = 'icon_barbarian_ship',
    red_circle = 'red_circle',
    green_circle = 'green_circle',
    grey_circle = 'grey_circle',

    ribbon_large = 'ribbon_large',
    ribbon_small = 'ribbon_small',
    ribbon_long = 'ribbon_long',
    ribbon_short = 'ribbon_short',

    white_number_one = 'white_number_one',

    icon_beginner_hint_initial_placement = 'icon_beginner_hint_initial_placement',

    icon_arrow = 'icon_arrow',
    icon_eye_hide = 'icon_eye_hide',
    icon_eye_show = 'icon_eye_show',
    icon_audio = 'icon_audio',
    icon_controls = 'icon_controls',
    icon_display = 'icon_display',
    icon_info = 'icon_info',
    icon_gift_box = 'icon_gift_box',
    icon_quit_game = 'icon_quit_game',

    icon_sheep = 'icon_sheep',

    membership_icon_plus = 'membership_icon_plus',
    membership_icon_premium = 'membership_icon_premium',
    membership_icon_elite = 'membership_icon_elite',
    membership_icon_holiday_2023 = 'membership_icon_holiday2023',

    notification_ribbon = 'notification_ribbon',
    notification_turn_update = 'notification_turn_update',
    notification_roll_seven = 'notification_roll_seven',
    notification_city_improvement = 'notification_city_improvement',

    player_status_accept = 'player_status_accept',
    player_status_pending = 'player_status_pending',
    player_status_reject = 'player_status_reject',

    empty = ''
}
